import { isPostgrestError } from '@examdojo/core/error-handling';

export function isClassLimitReachedError(error: unknown): boolean {
  return isPostgrestError(error) && error.code === 'ES403';
}
